import {compareNumericString, compareString } from './Comparison';

const tableHeaders =[
    {
    Header: 'Student ID',
    accessor: 'studentID', // accessor is the "key" in the data
    },
    {
        Header: 'Composite Score',
        accessor: 'composite',
        sortType: compareNumericString,
    },

    {
        Header: 'Total GPA',
        accessor: 'totalGPA',
    },
    {
        Header: 'GPA Percentile',
        accessor: 'percentile',
    },
    {
        Header: 'Average GPA Performance',
        accessor: 'aboveOrBelowGrade',
        sortType: compareNumericString,
    },
    {
        Header: 'Pass Rate',
        accessor: 'passRate',
    },
    // {
    // Header: 'Average Benefit Utilization',
    // accessor: 'avgBenefitUtil',
    // },
    // {
    // Header: 'Projected Benefit Utilization',
    // accessor: 'projectedBenefitUtil',
    // },
    {
    Header: 'Sparkline',
    accessor: 'sparklines',
    // {
    // Header: 'Projected Class Difficulty',
    // accessor: 'projectedClassDifficulty',
    },
    {
    Header: 'Progress Slope',
    accessor: 'progressSlope',
    sortType: compareNumericString,
    },
    // {
    //     Header: 'Major',
    //     accessor: 'major',
    // },
    // {
    // Header: 'Class Grade Correlation',
    // accessor: 'classCorrelation',
    // sortType: compareNumericString,
    // },
    // {
    // Header: 'Terms Attended',
    // accessor: 'termsAttended',
    // },
    // {
    // Header: 'Units Attempted',
    // accessor: 'unitsAttempted',
    // },
    // {
    // Header: 'Units Passed',
    // accessor: 'unitsPassed',
    // },    
    // {
    // Header: 'Next Term',
    // accessor: 'hasClasses',
    // sortType: compareString,
    // },
    
    
];

const studentHeader =[
    {
    Header: 'Student ID',
    accessor: 'studentID', // accessor is the "key" in the data
    },
    {
        Header: 'Composite Score',
        accessor: 'composite',
        sortType: compareNumericString,
    },

    {
        Header: 'Total GPA',
        accessor: 'totalGPA',
    },
    {
        Header: 'GPA Percentile',
        accessor: 'percentile',
    },
    {
        Header: 'Average GPA Performance',
        accessor: 'aboveOrBelowGrade',
        sortType: compareNumericString,
    },
    {
        Header: 'Pass Rate',
        accessor: 'passRate',
    },
    // {
    // Header: 'Average Benefit Utilization',
    // accessor: 'avgBenefitUtil',
    // },
    // {
    // Header: 'Projected Benefit Utilization',
    // accessor: 'projectedBenefitUtil',
    // },
    {
    Header: 'Sparkline',
    accessor: 'sparklines',
    },
    {
    Header: 'Progress Slope',
    accessor: 'progressSlope',
    sortType: compareNumericString,
    },
    // {
    //     Header: 'Major',
    //     accessor: 'major',
    // },
    // {
    // Header: 'Class Grade Correlation',
    // accessor: 'classCorrelation',
    // sortType: compareNumericString,
    // },
    // {
    // Header: 'Terms Attended',
    // accessor: 'termsAttended',
    // },
    // {
    // Header: 'Units Attempted',
    // accessor: 'unitsAttempted',
    // },
    // {
    // Header: 'Units Passed',
    // accessor: 'unitsPassed',
    // },    
    // {
    // Header: 'Next Term',
    // accessor: 'hasClasses',
    // sortType: compareString,
    // },
    
    
];


const forecastTable =[
{
Header: 'Student ID',
accessor: 'studentID', // accessor is the "key" in the data
},
{
    Header: 'History',
    accessor: 'history',
    sortType: compareString,
},
{
Header: 'Projected GPA',
accessor: 'projectedGPA',
sortType: compareNumericString,
},
{
Header: 'Classes Registered',
accessor: 'classesRegistered',
},
{
Header: 'Concern Score',
accessor: 'concernScore',
}
];
const tableHeaderClass =[
{
Header: 'Course',
accessor: 'course', // accessor is the "key" in the data
},
{
Header: 'Class Data Count',
accessor: 'classDataCount',
},
{
Header: 'Current Enrolled Count',
accessor: 'currentEnrolledCount',
},
{
Header: 'Classes Average Grade',
accessor: 'classAverageGrade',
}
];
const studentDataHeader =[
{
Header: 'Student ID',
accessor: 'studentID', // accessor is the "key" in the data
},
{
Header: 'Term',
accessor: 'term', // accessor is the "key" in the data
},
{
Header: 'Course',
accessor: 'course', // accessor is the "key" in the data
sortType: compareString,
},
{
Header: 'Grade Earned',
accessor: 'gradeEarned', // accessor is the "key" in the data
},
{
    Header: 'Units',
    accessor: 'units', // accessor is the "key" in the data
},
{
Header: 'Course Average Grade',
accessor: 'gradeAverage', // accessor is the "key" in the data
},
{
Header: 'Grade Difference',
accessor: 'gradeDifference'
},
{
Header: 'Term GPA',
accessor: 'termGPA', // accessor is the "key" in the data
},
]
const tutorDataHeader =[
    {
    Header: 'Student ID',
    accessor: 'studentID', // accessor is the "key" in the data
    },
    {
    Header: 'Course',
    accessor: 'course', // accessor is the "key" in the data
    },
    // {
    // Header: 'Course Link',
    // accessor: 'courseLink', // accessor is the "key" in the data
    // },
    {
    Header: 'Grade Earned',
    accessor: 'gradeEarned', // accessor is the "key" in the data
    },
    {
        Header: 'Grade Value',
        accessor: 'gradeValue', // accessor is the "key" in the data
    },
    {
    Header: 'Tutor or Needs Tutor',
    accessor: 'tutorOrNeeds', // accessor is the "key" in the data
    },
  
    {
    Header: ' Term',
    accessor: 'term', // accessor is the "key" in the data
    }
]

export default tableHeaders;

export {studentHeader, tableHeaders, forecastTable, tableHeaderClass, studentDataHeader, tutorDataHeader};